import React from 'react';
export function ProblemSection() {
  return <section className="py-20 px-4 sm:px-6 bg-white/50" data-id="element-96">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-97">
        {/* The Pattern */}
        <div className="prose prose-lg prose-stone mx-auto text-[#4A2C40]" data-id="element-98">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4A2C40] mb-8 text-center" data-id="element-99">
            You know the pattern.
          </h2>

          <p className="text-xl leading-relaxed" data-id="element-100">
            Two-ish weeks where you feel like yourself again. You’re cooking.
            Training. Focused. Optimistic.
          </p>

          <p className="text-xl leading-relaxed font-semibold" data-id="element-101">
            Then it happens.
          </p>

          <p className="text-lg leading-relaxed" data-id="element-102">
            You hit that stretch before your period where everything costs more:
          </p>

          <ul className="space-y-3 my-8 list-none pl-0" data-id="element-103">
            {['Food gets louder', 'Workouts feel heavier', 'Patience evaporates', 'Sleep goes weird', 'You start making "exceptions" that feel like a slide'].map((item, i) => <li key={i} className="flex items-start" data-id="element-104">
                <span className="mr-3 text-[#4A2C40] text-xl" data-id="element-105">•</span>
                <span className="text-lg text-[#4A2C40]/90" data-id="element-106">{item}</span>
              </li>)}
          </ul>

          <p className="text-xl leading-relaxed" data-id="element-107">
            And the worst part? It’s not even the cravings.{' '}
            <span className="italic" data-id="element-108">It’s the monthly reset.</span>
          </p>

          <div className="bg-[#F3EFE7] p-8 rounded-xl my-10 border-l-4 border-[#4A2C40]" data-id="element-109">
            <p className="text-xl md:text-2xl font-serif text-[#4A2C40] italic m-0" data-id="element-110">
              "The quiet shame of thinking: Why can’t I just be consistent?"
            </p>
          </div>

          <p className="text-xl leading-relaxed font-medium" data-id="element-111">
            You don’t need a stronger personality.
            <br data-id="element-112" />
            You need a plan that changes when your capacity changes.
          </p>
        </div>

        {/* The Shift */}
        <div className="mt-16 text-center" data-id="element-113">
          <h3 className="text-2xl font-serif font-bold text-[#4A2C40] mb-6" data-id="element-114">
            The problem isn’t you.
          </h3>
          <p className="text-lg text-[#4A2C40]/80 max-w-2xl mx-auto" data-id="element-115">
            It’s that you’ve been using one plan for a body that runs in phases.
            When you feel good, you build a routine like you’ll feel good
            forever. Then luteal arrives... and your plan collapses.
          </p>
        </div>
      </div>
    </section>;
}